export default __webpack_public_path__ + "static/media/Heavy Peaks.f7fc4fcf.png";